import { Component, OnInit } from '@angular/core';
import { ProjectService } from '../project.service';

@Component({
  selector: 'app-what-plaster',
  templateUrl: './what-plaster.component.html',
  styleUrls: ['./what-plaster.component.sass']
})
export class WhatPlasterComponent implements OnInit {
  next: string = "/questionnaire1";
  prev: string = "/finished-project";

  constructor(private projectService: ProjectService) { }

  ngOnInit() {
    let project = this.projectService.getProject();
    if (project.selectedMosaic) {
      this.prev = '/select-mosaic';
    }
  }
}
